/**
 * The order a deck gallery reads in: the deck in use first, then the rest as
 * the library lists them. The active deck is what a Mystic looks for; it
 * should never be the one they scroll to.
 */
export function orderDecks (decks, activeSlug) {
  const list = decks || []
  if (!activeSlug) return list.slice()
  const active = list.filter(d => d.slug === activeSlug)
  return active.concat(list.filter(d => d.slug !== activeSlug))
}
